export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20arrangement%20of%20premium%20sneakers%20designer%20accessories%20leather%20bags%20sunglasses%20and%20wristwatches%20on%20warm%20cream%20marble%20surface%20with%20eucalyptus%20leaves%20soft%20morning%20light%20streaming%20through%20linen%20curtains%20editorial%20fashion%20still%20life%20with%20organic%20textures%20golden%20accents%20and%20gentle%20shadows%20elegant%20european%20boutique%20aesthetic&width=1800&height=1300&seq=hero-collage-v2&orientation=landscape&nocache=true"
          alt="OOPBUY Spreadsheet Produkt Collage"
          title="OOPBUY Spreadsheet Deutschland Agent & QC Tool"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      <div className="relative z-10 h-full flex flex-col justify-center px-4 md:px-6">
        <div className="max-w-2xl">
          <h1 className="font-heading text-4xl md:text-6xl font-bold text-white leading-tight mb-4">
            OOPBUY<br />
            Spreadsheet<br />
            <span className="text-white/80">Deutschland</span>
          </h1>
          <p className="text-white/70 text-base md:text-lg max-w-lg mb-8 font-body">
            Das ultimative Tool für deinen Einkauf auf Taobao, Weidian & Yupoo. 
            QC, Agent & Shipping — alles in einem Spreadsheet.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-accent-500 text-white text-sm md:text-base font-semibold rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}